import { OrderPage } from './OrderPage';
export default OrderPage;